var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { domainService } from '~/config/server';
import { NetService } from '~/utils/net.service';
import { Inject } from '~/core/decorator';
import { Service } from '~/core/service';
var CarManageService = /** @class */ (function (_super) {
    __extends(CarManageService, _super);
    function CarManageService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * 车库管理查询列表
     */
    CarManageService.prototype.getAllGarages = function (data, page, sort) {
        return this.netService.send({
            server: domainService.carManageController.getAllGarages,
            data: data,
            page: page,
            sort: sort,
        });
    };
    /**
     * 新增车库
     */
    CarManageService.prototype.addGarage = function (data) {
        return this.netService.send({
            server: domainService.carManageController.addGarage,
            data: data
        });
    };
    /**
     * 修改车库
     */
    CarManageService.prototype.updateGarage = function (data) {
        return this.netService.send({
            server: domainService.carManageController.updateGarage,
            data: data
        });
    };
    /**
     * 库存车辆列表
     */
    CarManageService.prototype.getAllWarehouseCar = function (data, page) {
        return this.netService.send({
            server: domainService.carManageController.getAllWarehouseCar,
            data: data,
            page: page
        });
    };
    /**
     * 全部车库列表
     */
    CarManageService.prototype.getAllGaragesList = function () {
        return this.netService.send({
            server: domainService.carManageController.getAllGaragesList
        });
    };
    /**
     * 车库下面的所有库管员
     */
    CarManageService.prototype.getGarageUsersById = function (garageId) {
        return this.netService.send({
            server: domainService.carManageController.getGarageUsersById,
            data: {
                garageId: garageId
            }
        });
    };
    CarManageService.prototype.updateWarehouseCar = function (data) {
        return this.netService.send({
            server: domainService.carManageController.updateWarehouseCar,
            data: data
        });
    };
    CarManageService.prototype.getAllWarehouseApproval = function (data, page) {
        return this.netService.send({
            server: domainService.carManageController.getAllWarehouseApproval,
            data: data,
            page: page
        });
    };
    /**
     * 获取当前案件的库存车辆信息
     */
    CarManageService.prototype.getWarehouseCarByCaseInfoRecordId = function (taskId) {
        return this.netService.send({
            server: domainService.carManageController.getWarehouseCarByCaseInfoRecordId,
            data: {
                taskId: taskId
            }
        });
    };
    /**
     * 变更归属信息
     */
    CarManageService.prototype.updateApplyUserInfo = function (data) {
        return this.netService.send({
            server: domainService.carManageController.updateApplyUserInfo,
            data: data
        });
    };
    /**
     * 出入库审核
     */
    CarManageService.prototype.warehouseApproval = function (data) {
        return this.netService.send({
            server: domainService.carManageController.warehouseApproval,
            data: data
        });
    };
    /**
     * 车辆入库报表
     */
    CarManageService.prototype.getWarehouseCarReport = function (data, page) {
        return this.netService.send({
            server: domainService.carManageController.getWarehouseCarReport,
            data: data,
            page: page
        });
    };
    /**
     * 车辆入库报表导出
     */
    CarManageService.prototype.warehouseCarReportExport = function (data) {
        return this.netService.send({
            server: domainService.carManageController.warehouseCarReportExport,
            data: data
        });
    };
    /**
     * 库管审批报表导出
     */
    CarManageService.prototype.warehouseApprovalExport = function (data) {
        return this.netService.send({
            server: domainService.carManageController.warehouseApprovalExport,
            data: data
        });
    };
    __decorate([
        Inject(NetService)
    ], CarManageService.prototype, "netService", void 0);
    return CarManageService;
}(Service));
export { CarManageService };
